import { Component } from '@angular/core';
import { NavController, Nav } from 'ionic-angular';
import * as page from '../../pages/pages';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Storage } from '@ionic/storage';
import {HomePage} from './../pages';

@Component({
	selector: 'page-authorised-home',
	templateUrl: 'authorised-home.html'
})
export class AuthorisedHomePage {

	homeMenu: Array<{ title: string, icon: string, pageName: string, component: any;}>;
	menuDisplay: any;

	constructor(
		public navCtrl: NavController,
		private storage: Storage,
		private nav:Nav,
		private iab: InAppBrowser) {
	}

	ionViewDidLoad() {
		this.menuDisplay = [
            { title: 'eCom Conference 2020', icon: 'users', pageName: 'conference', component: page.ConferencePage},
            { title: 'My Badges', icon: 'trophy', pageName: 'badges', component: page.BadgesPage},
			{ title: 'Case Studies', icon: 'tasks', pageName: 'topics', component: page.TopicsPage},
			//{ title: 'Recent Videos', icon: 'video-camera', pageName: 'video',  component: page.VideoPage},	
			{ title: 'Visit Website', icon: 'info-circle', pageName: 'ecom-site',  component: null},
		];
	}

	goToPage(tile) {
		if (tile.pageName == "topics") {
			this.navCtrl.push(tile.component, tile.pageName);
		} else if (tile.pageName == "ecom-site"){
			this.iab.create("http://ecomscotland.com/", '_system');
		}else{
			this.navCtrl.push(tile.component);
		}
	}

	logout() {
		
			this.storage.remove('username');
			this.storage.remove('accessToken');
			this.storage.remove('currentRole');
			this.storage.remove('userId');
			this.storage.remove('name');
			this.nav.setRoot(HomePage);
	}

}



// WEBPACK FOOTER //
// ./src/pages/authorised-home/authorised-home.ts